export default {
  h1: {
    fontWeight: 500,
    fontSize: 55,
    lineHeight: "66px",
    fontFamily: "'Play', serif",
    "@media(max-width:767px)": {
      fontSize: "28px !important",
      lineHeight: "42px",
    },
  },
  h2: {
    fontSize: "40px",
    fontWeight: "700",
    lineHeight: "100px",
    fontFamily: "'Play', serif",
    "@media(max-width:767px)": {
      fontSize: "18px !important",
      lineHeight: "30px !important",
    },
  },
  h3: {
    fontWeight: 500,
    fontSize: 25,
    lineHeight: "30px",
    fontFamily: "'Play', serif",
    "@media(max-width:767px)": {
      fontSize: "15px !important",
    },
  },
  h4: {
    fontWeight: 500,
    fontSize: 20,
    lineHeight: "30px",
    fontFamily: "'Play', serif",
    "@media(max-width:767px)": {
      fontSize: "13px !important",
    },
  },
  h5: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: "30px",
    fontFamily: "'Play', serif",
    "@media(max-width:767px)": {
      fontSize: "16px !important",
    },
  },
  h6: {
    fontWeight: 500,
    fontSize: 16,
    lineHeight: "30px",
    fontFamily: "'Play', serif",
    "@media(max-width:767px)": {
      fontSize: "12px !important",
    },
  },

  button: {
    textTransform: "capitalize",
    borderRadius: 27,
  },
  body2: {
    fontSize: 15,
    lineHeight: "25px",
    fontWeight: 500,
    fontFamily: "'Play', serif",
    letterSpacing: "0.23px",
    "@media(max-width:767px)": {
      fontSize: "12px !important",
    },
  },
  body1: {
    fontSize: 12,
    lineHeight: "30px",
    fontFamily: "'Play', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "10px !important",
      lineHeight: "20px",
    },
  },
  overline: {
    fontWeight: 500,
  },
};
